import Image from "next/image";
import styles from "./Button.module.css";
import { CSSProperties, MouseEventHandler } from "react";
import useIsMobile from "../../../customHooks/IsMobile";
import { PAGE_TYPE } from "../../../utils/enums";

interface IButtonProps {
  text: string;
  leftIcon?: string;
  rightIcon?: string;
  color?: string;
  bgColor?: string;
  bgImage?: string;
  borderColor?: string;
  gradientBorder?: string;
  border?: string;
  onClick?: MouseEventHandler;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  disabled?: boolean;
  overridingStyles?: Object;
  leftIconOverridingStyles?: Object;
  rightIconOverridingStyles?: Object;
  link?: string;
  linkOnClick?: Function;
  pageType?: number;
}
export default function Button(props: IButtonProps) {
  const {
    text,
    border,
    gradientBorder,
    leftIcon,
    rightIcon,
    color,
    bgColor,
    bgImage,
    onClick,
    style = {},
    containerStyle = {},
    disabled,
    overridingStyles = {},
    leftIconOverridingStyles = {},
    rightIconOverridingStyles = {},
    link,
    linkOnClick,
    pageType,
  } = props;
  const { isMobileDevice } = useIsMobile();
  return (
    <div
      style={{
        padding: 1,
        backgroundImage: gradientBorder ? gradientBorder : "none",
        borderRadius: pageType === PAGE_TYPE.GCOE ? 0 : 4,
        width: isMobileDevice ? "100%" : "auto",
        pointerEvents: disabled ? "none" : "auto",
        ...containerStyle,
      }}
    >
      {link ? (
        <a
          href={link}
          target="_blank"
          style={{
            padding: "4px 10px",
            borderRadius: 4,
            border: border || "none",
            backgroundColor: bgColor || "#57cc03",
            backgroundImage: bgImage ? bgImage : "none",
            backgroundOrigin: "border-box",
            color: color || "#fff",
            fontSize: isMobileDevice ? 14 : "clamp(12px,2.08vw,20px)",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: isMobileDevice ? "100%" : "auto",
            textDecoration: "none",
            ...style,
            ...overridingStyles,
          }}
          onClick={() => linkOnClick && linkOnClick()}
        >
          {leftIcon && (
            <Image
              src={leftIcon}
              height={20}
              width={20}
              alt={text}
              style={{
                marginRight: 10,
                ...leftIconOverridingStyles,
              }}
            />
          )}
          {text}
          {rightIcon && (
            <Image
              src={rightIcon}
              height={20}
              width={20}
              alt={text}
              style={{
                marginLeft: 10,
                ...rightIconOverridingStyles,
              }}
            />
          )}
        </a>
      ) : (
        <button
          style={{
            padding: "4px 10px",
            borderRadius: pageType === PAGE_TYPE.GCOE ? 0 : 4,
            border: border || "none",
            backgroundColor: bgColor || "#57cc03",
            backgroundImage: bgImage ? bgImage : "none",
            backgroundOrigin: "border-box",
            color: color || "#fff",
            fontSize: isMobileDevice ? 14 : "clamp(12px,2.08vw,20px)",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: isMobileDevice ? "100%" : "auto",
            ...style,
            ...overridingStyles,
          }}
          onClick={onClick}
        >
          {leftIcon && (
            <Image
              src={leftIcon}
              height={20}
              width={20}
              alt={text}
              style={{
                marginRight: 10,
                ...leftIconOverridingStyles,
              }}
            />
          )}
          {text}
          {rightIcon && (
            <Image
              src={rightIcon}
              height={20}
              width={20}
              alt={text}
              style={{
                marginLeft: 10,
                ...rightIconOverridingStyles,
              }}
            />
          )}
        </button>
      )}
    </div>
  );
}
